import { AssetCardLayout } from "../../../../../../api/src/creative-unit-package/models/customization/customization.dto";

export const AssetCardLayouts: AssetCardLayout[] = [
	{
		id: 'grid-2',
		name: 'Grid: 2 per row',
		width: 350,
		height: 350
	},
	{
		id: 'grid-3',
		name: 'Grid: 3 per row',
		width: 300,
		height: 300
	},
	{
		id: 'grid-4',
		name: 'Grid: 4 per row',
		width: 250,
		height: 250
	},
	{
		id: 'grid-5',
		name: 'Grid: 5 per row',
		width: 200,
		height: 200
	},
	{
		id: 'grid-6',
		name: 'Grid: 6 per row',
		width: 150,
		height: 150
	},
	{
		id: 'grid-7',
		name: 'Grid: 7 per row',
		width: 100,
		height: 100
	},
	{
		id: 'grid-8',
		name: 'Grid: 8 per row',
		width: 50,
		height: 50
	},

];
